// Role-based routing configuration
export const roleRoutes = {
  admin: '/admin/dashboard',
  associado: '/associado/dashboard',
  comercial: '/comercial/dashboard',
  contabilidade: '/contabil/dashboard',
  diretoria_geral: '/diretoria-geral/dashboard',
  diretoria_comercial: '/diretoria-comercial/dashboard',
  diretoria_juridica: '/diretoria-juridico/dashboard',
  gestor_comercial: '/gestor-comercial/dashboard',
  gestor_juridico: '/gestor-juridico/dashboard',
  juridico: '/juridico/dashboard'
};

// Get dashboard route based on user role
export const getDashboardRoute = (userRole) => {
  return roleRoutes[userRole] || '/login';
};
